import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

// Single source of truth for the password policy shown live to the user.
// Keep in sync with Zitadel's policy and the backend (AuthService.ValidatePasswordPolicy).
export const PW_RULES: { label: string; test: (p: string) => boolean }[] = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'An uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'A lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'A number', test: (p) => /[0-9]/.test(p) },
];

export function passwordMeetsAll(password: string): boolean {
  return PW_RULES.every((r) => r.test(password));
}

/** Live password-requirements checklist — ticks each rule green as it's met. */
export function PasswordRequirements({ password }: { password: string }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        Your password must contain:
      </Typography>
      <List dense disablePadding>
        {PW_RULES.map((r) => {
          const ok = r.test(password);
          return (
            <ListItem key={r.label} disableGutters disablePadding sx={{ py: 0.25 }}>
              <ListItemIcon sx={{ minWidth: 28 }}>
                {ok ? (
                  <CheckCircleIcon fontSize="small" color="success" />
                ) : (
                  <RadioButtonUncheckedIcon fontSize="small" color="disabled" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={r.label}
                primaryTypographyProps={{
                  variant: 'body2',
                  color: ok ? 'text.primary' : 'text.secondary',
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
}
